import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const generateSignupLink = (callback, errCallback) => {
  return async (dispatch) => {
    dispatch({ type: 'GENERATING_SIGNUP_LINK' });
    let unsubscribe = onAuthStateChanged(auth, async (user) => {
      const token = await user.getIdToken();
      try {
        const response = await axios.get('/nf/invite/link', {
          params: {
            'request-id': uuidv4(),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(response);
        if (response.status === 200) {
          dispatch({
            type: 'GENERATING_SIGNUP_LINK_SUCCESSFUL',
          });
          if (typeof callback === 'function') callback(response.data);
        } else {
          dispatch({
            type: 'GENERATING_SIGNUP_LINK_FAILED',
            payload: response.data,
          });
          if (typeof errCallback === 'function') errCallback();
        }
      } catch (e) {
        console.log(e);
        dispatch({
          type: 'GENERATING_SIGNUP_LINK_FAILED',
          payload: e.message,
        });
        if (typeof errCallback === 'function') errCallback();
      }
      unsubscribe();
    });
  };
};

export default generateSignupLink;
